/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Tc_Generic_Aria_LabelInputs */

const en_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generic timecode input`)
};

const fr_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisie de timecode générique`)
};

const de_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generischer Timecode-Eingang`)
};

const it_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input di timecode generico`)
};

const ru_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Универсальный ввод временного кода`)
};

const es_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de código de tiempo genérico`)
};

const zh_cn2_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通用时间码输入`)
};

const ja_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汎用タイムコード入力`)
};

const hi_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य समयकोड इनपुट`)
};

const pt_pt2_input_tc_generic_aria_label = /** @type {(inputs: Input_Tc_Generic_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de código de tempo genérico`)
};

/**
* | output |
* | --- |
* | "Generic timecode input" |
*
* @param {Input_Tc_Generic_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_generic_aria_label = /** @type {((inputs?: Input_Tc_Generic_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Generic_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_tc_generic_aria_label(inputs)
	if (locale === "de") return de_input_tc_generic_aria_label(inputs)
	if (locale === "it") return it_input_tc_generic_aria_label(inputs)
	if (locale === "ru") return ru_input_tc_generic_aria_label(inputs)
	if (locale === "es") return es_input_tc_generic_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_input_tc_generic_aria_label(inputs)
	if (locale === "ja") return ja_input_tc_generic_aria_label(inputs)
	if (locale === "hi") return hi_input_tc_generic_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_input_tc_generic_aria_label(inputs)
	return en_input_tc_generic_aria_label(inputs)
});